import PropTypes from 'prop-types'
import React from 'react'
import Overlay from 'components/Overlay'
import { View } from 'components/View'
import TextBody from 'components/TextBody'

class Loader extends React.PureComponent {
  renderOverlay () {
    if (!this.props.hasOverlay) {
      return
    }
    return (
      <Overlay
        backgroundColor={Overlay.BACKGROUND_COLOR.WHITE}
      />
    )
  }

  render () {
    return (
      <div
        style={{
          bottom: '0',
          left: '0',
          position: 'absolute',
          right: '0',
          top: '0',
          pointerEvents: 'none'
        }}
      >
        <View
          style={{
            width: '100%',
            height: '100%',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: Overlay.Z_INDEX + 1
          }}
        >
          <TextBody
            style={{
              zIndex: Overlay.Z_INDEX + 1
            }}
          >
            Loading...
          </TextBody>
        </View>
        {this.renderOverlay()}
      </div>
    )
  }
}

Loader.propTypes = {
  hasOverlay: PropTypes.bool,
  hasFixedSize: PropTypes.bool
}

export default Loader
